import React, { useState } from "react";
import "./Buttons.scss";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchExamInstructionRequest,
  setTestDetails,
  setTestId,
  setTestType,
  setSelectedSetId,
  setPaperId,
} from "../../../../../redux/exam/examSlice";
import GameficationMode from "../../../../tests/Dashboard/GameficationMode";

const Buttons = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { testDetails } = useSelector((state) => state.examSlice);
  const [showGameMode, setShowGameMode] = useState(false);

  /**
   * Open gamification modal only when timed test attempts are exhausted.
   * Backend sets `attempt_message` in that case (same red copy as on the test card).
   */
  const shouldOpenPracticeModeModal = () =>
    Boolean(
      testDetails?.attempt_message &&
        String(testDetails.attempt_message).trim() !== ""
    );

  const handleGameModeConfirm = ({ selectedMode, gamificationOn }) => {
    const payload = {
      ...testDetails,
      practiceMode: selectedMode,
      gamificationOn,
      forceFreshStart: true,
      isResume: false,
    };

    const storageId = payload.setId ?? payload.testId ?? payload.paperId;
    if (storageId != null && storageId !== "") {
      localStorage.setItem(
        `exam_mode_${storageId}`,
        payload.practiceMode || "test"
      );
      localStorage.setItem(
        `exam_gamification_${storageId}`,
        payload.gamificationOn ? "1" : "0"
      );
    }

    dispatch(setTestId(payload.testId));
    dispatch(setTestType({ id: payload.paperType }));
    dispatch(setSelectedSetId(payload.setId ?? null));
    if (payload.paperId != null && payload.paperId !== undefined) {
      dispatch(setPaperId(payload.paperId));
    }
    dispatch(setTestDetails(payload));
    dispatch(fetchExamInstructionRequest(payload));
    setShowGameMode(false);
    history.push("/TestInstruction");
  };

  const handleReattempt = () => {
    if (!testDetails?.paperId && !testDetails?.setId) return;

    if (shouldOpenPracticeModeModal()) {
      setShowGameMode(true);
      return;
    }

    const payload = {
      ...testDetails,
      forceFreshStart: true,
      isResume: false,
      attempt_count: 0,
    };
    dispatch(setTestDetails(payload));
    dispatch(fetchExamInstructionRequest(payload));

    history.push("/TestInstruction");
  };

  const handleSeeResponse = () => {
    history.push("/adv-analytics", { tab: "questionwise" });
  };

  return (
    <div className="basicAnalytics__buttons">
      <div
        className="basicAnalytics__buttons__button"
        onClick={handleReattempt}
      >
        Reattempt
      </div>

      <div
        className="basicAnalytics__buttons__button"
        onClick={handleSeeResponse}
      >
        See Response
      </div>

      <GameficationMode
        isOpen={showGameMode}
        onClose={() => setShowGameMode(false)}
        onConfirm={handleGameModeConfirm}
        attemptMessage={testDetails?.attempt_message}
        testName={testDetails?.test_name || testDetails?.set_name || ""}
      />
    </div>
  );
};

export default Buttons;
